var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnPointLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6875C17.9025 22.6875 22.6875 17.9025 22.6875 12C22.6875 6.09746 17.9025 1.3125 12 1.3125C6.09746 1.3125 1.3125 6.09746 1.3125 12C1.3125 17.9025 6.09746 22.6875 12 22.6875Z",
    fill: "#FEDA2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.2387C16.5501 20.2387 20.2387 16.5501 20.2387 12C20.2387 7.44985 16.5501 3.76123 12 3.76123C7.44985 3.76123 3.76123 7.44985 3.76123 12C3.76123 16.5501 7.44985 20.2387 12 20.2387Z",
    fill: "#FCAA17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.66852L13.8737 9.46502L18.0632 10.0738L15.0317 13.029L15.7474 17.2016L12 15.2316L8.25265 17.2016L8.96833 13.029L5.93665 10.0738L10.1263 9.46502L12 5.66852Z",
    fill: "#FEDA2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnPointLogo);
export default __webpack_public_path__ + "static/media/earn-point-logo.17893e8a630d36cd9aa95030c8c6251b.svg";
export { ForwardRef as ReactComponent };